export default "__VITE_ASSET__C8vvnY6C__"